import React, { useContext, useEffect, useState } from 'react'
import { ApiGetCDNData, ApiPostCallAuthKey } from '../../JS/Connector';
import { CheckValidation, ValidateFile } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import Popup from '../../Components/Popup';
import ImagesPopup from '../../Components/ImagesPopup';
import { log } from '../../JS/Logger';
import { useSelector } from 'react-redux';
import useConfig from '../../Hooks/useConfig';

export default function CommentPopup(props) {
    const {user_no, manager_user, staff_member} = useConfig();
    const StateData = useSelector((state) => state.authData);
    var CommentData = props.CommentData;
    var setAllData = props.setAllData;
    var allData = props.allData;
    const [PopupImage, SetPopupImage] = useState(null);
    const [PopupVideo, SetPopupVideo] = useState(null);
    const [showImagesModal, setShowImagesModal] = useState({
        show: false,
        activeIndex: 0,
        zoomInOut: false,
    });
    useEffect(() => {
        if (CommentData.img) {
            ApiGetCDNData("/" + CommentData.img, StateData?.Schoolnumber).then((result) => {
                try {
                    var url = URL.createObjectURL(result);
                    if (url) SetPopupImage(url);
                } catch (err) {
                    log.error(err);
                }
            });
        }
        if (CommentData.video_path) {
            ApiGetCDNData("/" + CommentData.video_path, StateData?.Schoolnumber).then((result) => {
                try {
                    var url = URL.createObjectURL(result);
                    if (url) SetPopupVideo(url);
                } catch (err) {
                    log.error(err);
                }
            });
        }
    }, [CommentData.img, CommentData.video_path]);
    function handleImageFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "image", maxSizeMB: 2 });
        if (!isFileValid) {
            props.setAlerts(<AlertsComp show={true} variant="danger" msg={validationMsg} />);
            setTimeout(() => {
                props.setAlerts(<AlertsComp show={false} />);
            }, 2000);
            return;
        }
        const reader = new FileReader();
        reader.onload = function (event) {
            const base64String = event.target.result;
            const base64Value = base64String.split(";base64,").pop();
            setAllData({ ...allData, fileName: file.name, Flag: 1, Documentt: base64Value });
        };
        reader.readAsDataURL(file);
    };
    async function SaveComment() {
        var isFormValid = CheckValidation({ formID: 'CommentDiv' });
        if (!isFormValid) return;
        props.setLoading(true);
        var raw = JSON.stringify({
            schoolId: StateData?.SchoolId,
            ticketNumber: allData.TicketNum,
            userEmail: null,
            comment: allData.Comment,
            assignStaffMemberId: StateData?.csvUserID || null,
            flag: 1,
            document: allData.Documentt,
            commentFlag: 2
        });
        await ApiPostCallAuthKey("/support-tickets/add-comment", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                props.setLoading(false);
                if (result == "success") {
                    props.setAlerts(<AlertsComp show={true} variant="success" msg={"Comment Successfully."} />);
                    setTimeout(() => {
                        setAllData({ ...allData, Filename: '', Description: '', Comment: '', Documentt: '' });
                        props.setIsComment();
                        props.GetAllSupportTickets(1, null, null);
                        props.setAlerts(<AlertsComp show={false} />);
                    }, 1500);
                }
                else {
                    props.setAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        props.setAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const modalBody = (
        <>
            <div className="row px-2">
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600">Ticket # : </div>
                    <div className="col-md-6">{CommentData.support_ticket_num || '-'}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600">Ticket Subject : </div>
                    <div className="col-md-6" style={{ wordWrap: "break-word" }}>{CommentData.title || '-'}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pt-0 pe-0 row">
                    <div className="col-md-6 fw-600"> Name : </div>
                    <div className="col-md-6"> {CommentData.name || '-'}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600">Email : </div>
                    <div className="col-md-6" style={{ wordBreak: 'break-all' }}>{CommentData.email || '-'}</div>
                </div>
                {CommentData.role == 2 && (
                    <div className="col-xl-6 col-12 p-1 pe-0 row">
                        <div className="col-md-6 fw-600"> Room No. : </div>
                        <div className="col-md-6">{CommentData.room_name ? CommentData.room_name : CommentData.room ? CommentData?.room?.name : '-'}</div>
                    </div>
                )}
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600"> Building : </div>
                    <div className="col-md-6 text-break">{CommentData.other_building_name ? CommentData.other_building_name : CommentData?.building?.name}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600">{user_no}: </div>
                    <div className="col-md-6">{CommentData.student_num || '-'}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600"> Role : </div>
                    <div className="col-md-6">{CommentData.role == 1 ? manager_user : staff_member}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600">Issue Type :  </div>
                    <div className="col-md-6">{CommentData.IssueType || '-'}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pe-0 row">
                    <div className="col-md-6 fw-600">Attached Image : </div>
                    <div className="col-md-6">{PopupImage ?
                        <img src={PopupImage} height="25px" onClick={() => setShowImagesModal({ ...showImagesModal, show: true, activeIndex: 0 })} /> : '-'}</div>
                </div>
                <div className="col-xl-6 col-12 p-1 pe-0 row align-items-center">
                    <div className="col-md-6 fw-600">Attached Video : </div>
                    <div className="col-md-6">
                        {PopupVideo ?
                            <iframe
                                width="200"
                                height="100"
                                src={PopupVideo}
                                frameborder="0"
                                allowfullscreen
                            ></iframe>
                            :
                            <>-</>
                        }
                    </div>
                </div>
                <div className="col-xl-12 col-12 p-1 pb-3 pe-0 row">
                    <div className="col-md-3 fw-600">Ticket Description :  </div>
                    <div className="col-md-9">{CommentData.description || '-'}</div>
                </div>
            </div>
            <div id="CommentDiv" className="parent row">
                <div className='col-md-6 pt-3'>
                    <textarea rows={4} required autoComplete='off' name='comment' className="form-control"
                        value={allData.Comment} onChange={(e) => setAllData({ ...allData, Comment: e.target.value })} />
                    <div className='FormLabel'>Comment<label className='redText'>*</label></div>
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                </div>
                <div className='col-md-6 pt-3'>
                    <input type="file" label="img" id="UploadFileId" name="myFile" accept=".jpg,.png,.jpeg" onChange={(e) => handleImageFileUpload(e)} />
                    <label className="ImportInventoryBtn col-md-8" htmlFor="UploadFileId">
                        Choose File
                    </label>
                    <input type="file" className=" col-md-4 ImportInventoryBtn" />
                    <label className="ImportInventoryBtn1 text-center col-md-4" htmlFor="UploadFileId" style={{ backgroundColor: "var(--primary-color)", color: "white", height: "40px", }}>
                        Browse
                    </label>
                    <div className='col-12 FormLabel'>Attach Image or Screenshot</div>
                    {allData.fileName && <label className="ps-2 mt-1" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{allData.fileName} </label>}
                </div>
            </div>
        </>
    )
    return (
        <>
            <Popup isshow={props.IsComment} size={"lg"} title={CommentData.type == 1 ? "Technology Support Ticket Comments" : "Maintenance Support Ticket Comments "}
                closePopup={(e) => { props.setIsComment(); setAllData({ ...allData, Filename: '', Description: '', Comment: '', Documentt: '' }); }}
                modalBody={modalBody} handleSave={SaveComment} visibleSaveBtn={true} btnText={"Comment"} isBlur={showImagesModal.show} />

            <ImagesPopup
                AllImages={[PopupImage]}
                isShow={showImagesModal.show}
                closePopup={() => setShowImagesModal({ ...showImagesModal, show: false, activeIndex: 0, zoomInOut: false })}
                title={"Preview Images"}
                size={"xl"}
                activeIndex={showImagesModal.activeIndex}
                handleActiveIndex={(selectedIndex) => setShowImagesModal((prev) => ({ ...prev, activeIndex: selectedIndex, zoomInOut: false }))}
                zoomInOut={showImagesModal.zoomInOut}
                handleZoomInOut={() => setShowImagesModal({ ...showImagesModal, zoomInOut: !showImagesModal.zoomInOut })}
            />
        </>
    )
}
